export const createCartApis = instance => ({
  add: data => instance.post('/distributor/shoppingCart/add', data),
  update: data => instance.put('/distributor/shoppingCart/productQuantity/update', data),
  delete: id => instance.delete(`/distributor/shoppingCart/delete/${id}`),
  list: distributorIdentifier => instance.get(`/distributor/shoppingCart/list?identifier=${distributorIdentifier}`),
})
